import { Stack, Text } from '@ltvco/refresh-lib/theme';
import React from 'react';

import { SearchReport } from 'icons';

import { NO_RESULTS_TIPS } from '../../constants';

import {
  NoResultsContainer,
  NoResultsIcon,
  NoResultsTipsContainer,
  NoResultsBullet,
} from './components';

export interface NoResultsProps {
  searchQuery: string;
  type?:
    | 'opinions'
    | 'cases'
    | 'oral-arguments'
    | 'judge-search'
    | 'class-action-lawsuits'
    | 'general';
}

export const NoResults: React.FC<NoResultsProps> = ({
  searchQuery,
  type = 'general',
}) => {
  const typeTextMap = {
    opinions: 'opinions',
    cases: 'cases',
    'oral-arguments': 'oral arguments',
    'judge-search': 'judges',
    'class-action-lawsuits': 'class action lawsuits',
    general: 'results',
  } as const;

  const typeText = typeTextMap[type];
  const tips = NO_RESULTS_TIPS;

  return (
    <NoResultsContainer>
      <Stack spacing={4} alignItems="center">
        {/* Icon Section */}
        <NoResultsIcon as={SearchReport} />

        {/* Main Message */}
        <Stack spacing={1} alignItems="center">
          <Text variant="h4" fontWeight="600" color="text.primary">
            No {typeText} found
          </Text>
          <Text variant="body1" color="text.secondary">
            Your search for &quot;{searchQuery}&quot; had no results.
          </Text>
        </Stack>

        {/* Search Tips Container */}
        <NoResultsTipsContainer>
          <Stack spacing={2}>
            <Text variant="body1" fontWeight="600" color="text.primary">
              Search tips:
            </Text>
            <Stack spacing={1}>
              {tips.map((tip) => (
                <Stack
                  key={tip.id}
                  direction="row"
                  spacing={1}
                  alignItems="center"
                >
                  <NoResultsBullet component="span">•</NoResultsBullet>
                  <Text variant="body2" color="text.secondary">
                    {tip.text}
                  </Text>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </NoResultsTipsContainer>
      </Stack>
    </NoResultsContainer>
  );
};
